import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import Header from "./HeaderAuth";
import Footer from "./Footer";
import Title from "./Title";

interface PageContainerProps {
    section: string;
    pageTitle: string;
    backDestination?: string | null;
    children?: ReactNode;
}

export default function PageContainerAuth({ section, pageTitle, backDestination = null, children = null }: PageContainerProps) {
    return (
        <div className="root">

            <Helmet>
                <title>IKEA - AutoMail</title>
            </Helmet>

            <div id="pg" className="automail">
                <Header />

                <main id="pg-main">
                    <section className={`slice ${section}`}>
                        <div className="slice-wrapper">
                            <Title title={pageTitle} backDestination={backDestination} />
                            <div className="slice-content">
                                {children}
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        </div>
    );
}